import { Input, Modal } from "@findemdev/maui";
import { useState } from "react";
import { CopyCredentialModalContent, InputHelperText } from "./CopyCredential.styled";
import { decodeString } from "@findemdev/findem-helpers";

interface ICopyCredentialProps {
  open: boolean;
  newCredName: string;
  onClose: () => void;
  isCopyPending: boolean;
  handleMakeCopy: ({ newCredName }: { newCredName: string }) => Promise<void>;
}

const CopyCredential = ({ handleMakeCopy, isCopyPending, onClose, open, newCredName }: ICopyCredentialProps) => {

  const [copyCredName, setCopyCredName] = useState<string>(decodeString(newCredName));

  const handleMakeCopyInternal = async () => {
    await handleMakeCopy({ newCredName: decodeString(copyCredName) });
  }

  const onChangeCopyName = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCopyCredName(e.target.value);
  }

  return <Modal
    title="Make a Copy"
    open={open}
    onOk={handleMakeCopyInternal}
    onCancel={onClose}
    okText="Create"
    okButtonProps={{ loading: isCopyPending, disabled: isCopyPending || !copyCredName.trim() }}
  >
    <CopyCredentialModalContent>
      <InputHelperText variant="boldData">Credential Name</InputHelperText>
      <Input
        width={"100%"}
        defaultValue={decodeString(newCredName)}
        onChange={onChangeCopyName}
        placeholder="Enter your Credential name"
      />
    </CopyCredentialModalContent>
  </Modal>
};

export default CopyCredential;